import React, { useEffect } from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';
import ContactInformation from '../components/ContactInformationComponent';
import FeedbackFormComponent from '../components/FeedbackFormComponent';
import QuestionSelectionComponent from '../components/QuestionSelectionsComponent';
import ThankYouComponent from '../components/ThankYouComponent';
import './FeedbackFormView.css';
import {connect} from 'react-redux';
import {isAuthenticated,falseIfUndefined,isPersonaAuthenticated} from 'utils/HelperFunctions';
import * as FeedbackFormViewActions from '../actions/FeedbackFormView';
import * as constants from 'constants/App';
import Spinner from 'components/Spinner';
import FormWrapper from 'components/FormWrapper';
import configuration from 'configuration';
import {Map} from "immutable";
import { useNavigate } from 'react-router-dom';

const FeedbackFormView = (props) => {
    const navigate = useNavigate();
    
    const history = {
        push: (path) => navigate(path),
        replace: (path) => navigate(path, { replace: true }),
        goBack: () => navigate(-1)
    };

    useEffect(() => {
        props.dispatch(FeedbackFormViewActions.mountDataFeedbackForm());
        props.dispatch({type:constants.CLEAR_ERROR_MESSAGE});
    }, []);

    const submitHandler = (event) => {
        event.preventDefault();

       if(typeof window !== 'undefined'
           && typeof window.grecaptcha !== 'undefined'
           && typeof window.grecaptcha.render === 'function') {
           let feedBackData = Map({
               reCaptchaVerificationToken: !props.login && !props.loginPersona ? grecaptcha.getResponse() : ""
           });
           let reCaptchaCheck = feedBackData.map((x) => {
               return x
           }).first();

           onSaveHandler(feedBackData);

           if (reCaptchaCheck !== "" && !props.login && !props.loginPersona) {
               props.dispatch({type: constants.SEND_FEEDBACK_FORM_CLICKED});
           }
       }
       if(props.login || props.loginPersona){
        props.dispatch({type: constants.SEND_FEEDBACK_FORM_CLICKED});
       }
    };

    const onSaveHandler = (postData) => {
        props.dispatch(FeedbackFormViewActions.saveFeedbackForm(postData));
    };

    const onDropHandler = (postData) => {
        props.dispatch(FeedbackFormViewActions.saveDataFeedbackFormSelect(postData));
    };
    
    const NavigateToHelpFAQ = (event) => {    
        event.preventDefault();        
        props.dispatch({type: constants.NAVIGATE_TO, path: '/contact/HelpFAQ'});
    };

    const {country,form,isSendingData,isApprovedData} = props;
 
    const isUserLoggedIn = props.login  || props.loginPersona;
        const messages = defineMessages({
            feedback_form_header: {
                id: 'feedback_form_header',
                description: 'Header for feedback form non public page',
                defaultMessage: 'Feedback Form'
            },
            faq_footer1: {
                id: 'faq_footer1',
                description: 'Help FAQ quick link',
                defaultMessage: 'You may find answers to your questions and concerns in our '
            },
            faq_footer2: {
                id: 'faq_footer2',
                description: 'Frequently Asked Questions',
                defaultMessage: 'Frequently Asked Questions.'
            }, active_address_header: {
                id: 'active_address_header',
                description: 'Address of contact information',
                defaultMessage: 'Holman Global Headquarters <br/> 4001 Leadenhall Road <br/> Mount Laurel, NJ 08054'
            }, canadian_active_address_header: {
                id: 'canadian_active_address_header',
                description: 'Canadian address of contact information',
                defaultMessage: 'Holman Financial Services Inc. <br/> 1270 Central Parkway W. <br/> Suite 600 <br/> Mississauga, Ontario L5C 4P4 <br/> 800-361-5882'
            }, mexican_active_address_header:{
                id:'mexican_active_address_header',
                description:'Boulevard Manuel Avila Camacho #685 <br/> Fraccionamiento Industrial Alce Blanco <br/>    Naucalpan Mexico 53370 ',
                defaultMessage: 'Boulevard Manuel Avila Camacho #685 <br/> Fraccionamiento Industrial Alce Blanco <br/>    Naucalpan Mexico 53370 ',
            }
        });
        if (isSendingData) {
            return <Spinner />;
        }

        return <div>

            {isApprovedData == true  ?  <ThankYouComponent login={props.login} loginPersona={props.loginPersona} personaDefaultStoreId={props.personaDefaultStoreId} isCarWashVendor={props.isCarWashVendor} />
                : <div>
                 <FormWrapper key='feedbackFormGenericErrorMessage' 
                         id="feedbackFormGenericErrorMessage" {...props} 
                         formErrors={props.feedbackFormGenericErrorMessage} />

                 <FormWrapper key='feedbackFormErrorMessage' 
                         id="feedbackFormErrorMessage" {...props} 
                         formErrors={props.feedbackFormErrorMessage} />
                    {props.country.get('selectedCountry') === "USA" ?  <div className="row feedback__spacing">
                        <div className="col-sm-4 feedback-information__address-header">

                            <FormattedMessage {...messages.active_address_header} values={{ br: data => <br/> , b: data => <b>{data}</b>, a: data => <a>{data}</a>}}/>

                        </div>
                        <h3 className="col-8 feedback-title__header">
                            <FormattedMessage {...messages.feedback_form_header}/>
                        </h3>
                    </div>
                        :
                        props.country.get('selectedCountry')==='MEX'? <div className="row feedback__spacing">
                        <div className="feedback-information__address-header">

                            <FormattedMessage {...messages.mexican_active_address_header} values={{ br: data => <br/> , b: data => <b>{data}</b>, a: data => <a>{data}</a>}}/>

                        </div>
                        <h3 className="feedback-title__header">
                            <FormattedMessage {...messages.feedback_form_header}/>
                        </h3>
                    </div>
                    :

                        <div className="row feedback__spacing">
                            <div className="feedback-information__address-header">

                                <FormattedMessage {...messages.canadian_active_address_header} values={{ br: data => <br/> , b: data => <b>{data}</b>, a: data => <a>{data}</a>}}/>

                            </div>
                            <h3 className="feedback-title__header-canadian">
                                <FormattedMessage {...messages.feedback_form_header}/>
                            </h3>
                        </div>
                    }
                <div>
                    <ContactInformation country={country.get('selectedCountry')}  login={isUserLoggedIn}/>
                </div>
                <div>
                    <QuestionSelectionComponent login={isUserLoggedIn}
                                               onSaveForm={onDropHandler}/>
                </div>

                    <p>&nbsp;</p>
                    <div>
                        <FeedbackFormComponent login={isUserLoggedIn} history={history}
                                               onSaveForm={onSaveHandler}
                                               onSubmitter={submitHandler}
                                               reCaptchaKey={configuration.reCaptchaKey}
                                               reCaptchaVerificationToken={props.reCaptchaVerificationToken}
                        />

                    </div>
                    <div className="feedback-helpLink__div">
                        <FormattedMessage {...messages.faq_footer1}/>
                        <a href='#' onClick={NavigateToHelpFAQ}><FormattedMessage {...messages.faq_footer2}/></a>
                    </div>


            </div>

            }
        </div>;
}

function select(state) {

    return {
        country: state.appState.getIn(['uiData', 'shared']),
        form: state.appState.getIn(['uiData','feedbackForm']),
        isSendingData: falseIfUndefined(state.appState.getIn(['uiData', 'feedbackForm','isSendingData'])),
        login:isAuthenticated(state),
        loginPersona: isPersonaAuthenticated(state),
        isApprovedData: state.appState.getIn(['uiData', 'feedbackForm','isApprovedData']),
        feedbackFormGenericErrorMessage:state.appState.getIn(['uiData','shared','errorMessage']),
        feedbackFormErrorMessage:state.appState.getIn(['uiData','feedbackForm','errorMessage']),
        isCarWashVendor:state.appState.getIn(['serverData','shared','serviceClassification']),
        reCaptchaVerificationToken: state.appState.getIn(['uiData', 'feedbackForm', 'reCaptchaVerificationToken']),
        personaDefaultStoreId: state.appState.getIn(['serverData', 'shared', 'personaUser','defaultStoreId'])
    };
}

export default connect(select)(FeedbackFormView);
